export default __webpack_public_path__ + "static/media/981.0b8ce192.png";